/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Owner } from './bvq';
import { EntityType } from './enums/entity.type';
import * as moment from 'moment';

export class CorporateEntity {
  ID: string;
  NAME: string;
  DBA: string;
  IS_DEFAULT: boolean;
  ORDER: number;
  TYPE: EntityType;
  STATE_INCORPORATED: string;
  DATE_INCORPORATED: string; // New
  OWNERS: Owner[]; // New

  // Helper
  TOTAL_PERCENTAGE: number;
  TOTAL_ERROR: number;

  static parse(json: any): CorporateEntity {
    if (json) {
      const c = new CorporateEntity();

      c.ID = json.ID;
      c.NAME = json.NAME;
      c.DBA = json.DBA;
      c.IS_DEFAULT = Boolean(json.IS_DEFAULT);
      c.ORDER = json.ORDER;
      c.TYPE = EntityType[<string>json.TYPE];
      c.STATE_INCORPORATED = json.STATE_INCORPORATED;
      c.DATE_INCORPORATED = json.DATE_INCORPORATED ? moment(json.DATE_INCORPORATED).format('MM/DD/YYYY') : '';
      c.OWNERS = json.OWNERS ? Owner.parseArray(json.OWNERS) : [];

      return c;
    } else return null;
  }

  static parseArray(json: any[]): CorporateEntity[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(CorporateEntity.parse(j));

    return arr;
  }

  getTotalPercentage(): any {
    if(Number.isInteger(this.TOTAL_PERCENTAGE))
      return this.TOTAL_PERCENTAGE
    else
      return Number(this.TOTAL_PERCENTAGE).toFixed(2);
  }
  getFullDetails(): string {
    return this.NAME;
  }
}
